import { constants } from "../../../constants";

export default class ExitFullScreen {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        if (this.gb.settings && this.gb.settings.fullScreenMode) {
            this.gb.emitters.emit.web.exitFullScreen();
        } else {
            logger.debug(`setting fullScreenMode is not setup in aggregator`);
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.STAKELOGIC2:
                event["FULLSCREEN_MODE_OFF"] = this._default;
                break;
            case constants.KAJ:
                event['game.fullscreen.exit'] = this._default;
                break;
            default:
                event["exitFullScreen"] = this._default;
        }

        return event;
    }
}
